import request from '@/utils/request'
export function pushSchedule(team1_name,team2_name,opentime,closetime){
    return request.post('/api/v1/admin/game',{
        team1_name,
        team2_name,
        opentime,
        closetime
    })
}